import { render, staticRenderFns } from "./carefullyChosen.vue?vue&type=template&id=708e4b93&scoped=true&"
import script from "./carefullyChosen.vue?vue&type=script&lang=js&"
export * from "./carefullyChosen.vue?vue&type=script&lang=js&"
import style0 from "./carefullyChosen.vue?vue&type=style&index=0&id=708e4b93&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "708e4b93",
  null
  
)

export default component.exports